'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = require('./scroller');

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollSpy = require('./scroll-spy');

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-env browser  */
/**
 * Exports a helper function which wraps clickable elements, hijacking onClick and passing it to the scroller
 */


function handleClick(onClick, href, event) {
    event.stopPropagation();
    event.preventDefault();

    if (onClick) {
        onClick(event);
    }

    _get__('scroller').prepareToScroll(href);
}

function anchor(Component) {
    var AnchorComponent = function (_get__$Component) {
        _inherits(AnchorComponent, _get__$Component);

        function AnchorComponent(props) {
            _classCallCheck(this, AnchorComponent);

            var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AnchorComponent).call(this, props));

            _this._handleScroll = _this._handleScroll.bind(_this);
            return _this;
        }

        _createClass(AnchorComponent, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                _get__('ScrollSpy').registerLink(this);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                _get__('ScrollSpy').unregisterLink(this);
            }
        }, {
            key: '_handleScroll',
            value: function _handleScroll(scrollOffset, container, element) {
                // eslint-disable-next-line react/no-find-dom-node
                var link = _get__('ReactDOM').findDOMNode(this);
                var cords = element.panel.getBoundingClientRect();
                var containeRect = container.getBoundingClientRect();

                var elemTopBound = 0;
                if (container === document.body) {
                    elemTopBound = cords.top - containeRect.top - 64;
                } else {
                    elemTopBound = cords.top + scrollOffset - containeRect.top - 64;
                }
                var elemBottomBound = elemTopBound + cords.height;

                return _extends({}, element, {
                    link: link,
                    activeClass: this.props.activeClass,
                    hasActive: link.classList.contains(this.props.activeClass),
                    isInside: {
                        elementTop: elemTopBound,
                        elementBottom: elemBottomBound,
                        element: cords,
                        container: containeRect
                    }
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props;
                var _onClick = _props.onClick;

                var props = _objectWithoutProperties(_props, ['onClick']); // eslint-disable-line no-use-before-define


                var restProps = _extends({}, _get__('omit')(props, ['activeClass']), {
                    onClick: function onClick(event) {
                        return _get__('handleClick')(_onClick, props.href, event);
                    }
                });
                return _get__('React').createElement(Component, restProps);
            }
        }]);

        return AnchorComponent;
    }(_get__('React').Component);

    AnchorComponent.displayName = 'AnchorComponent(' + (Component.displayName || Component.name) + ')';
    AnchorComponent.propTypes = {
        href: _get__('PT').string.isRequired,
        onClick: _get__('PT').func,
        activeClass: _get__('PT').string
    };
    AnchorComponent.defaultProps = {
        activeClass: 'scroll-spy-active'
    };

    return AnchorComponent;
}

exports.default = _get__('anchor');

var _RewiredData__ = Object.create(null);

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
    function addPropertyToAPIObject(name, value) {
        Object.defineProperty(_RewireAPI__, name, {
            value: value,
            enumerable: false,
            configurable: true
        });
    }

    addPropertyToAPIObject('__get__', _get__);
    addPropertyToAPIObject('__GetDependency__', _get__);
    addPropertyToAPIObject('__Rewire__', _set__);
    addPropertyToAPIObject('__set__', _set__);
    addPropertyToAPIObject('__reset__', _reset__);
    addPropertyToAPIObject('__ResetDependency__', _reset__);
    addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
    if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
        return _get_original__(variableName);
    } else {
        var value = _RewiredData__[variableName];

        if (value === INTENTIONAL_UNDEFINED) {
            return undefined;
        } else {
            return value;
        }
    }
}

function _get_original__(variableName) {
    switch (variableName) {
        case 'scroller':
            return _scroller2.default;

        case 'ScrollSpy':
            return _scrollSpy2.default;

        case 'ReactDOM':
            return _reactDom2.default;

        case 'omit':
            return _utils.omit;

        case 'handleClick':
            return handleClick;

        case 'React':
            return _react2.default;

        case 'PT':
            return _react.PropTypes;

        case 'anchor':
            return anchor;
    }

    return undefined;
}

function _assign__(variableName, value) {
    if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
        return _set_original__(variableName, value);
    } else {
        return _RewiredData__[variableName] = value;
    }
}

function _set_original__(variableName, _value) {
    switch (variableName) {}

    return undefined;
}

function _update_operation__(operation, variableName, prefix) {
    var oldValue = _get__(variableName);

    var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

    _assign__(variableName, newValue);

    return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
    if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
        Object.keys(variableName).forEach(function (name) {
            _RewiredData__[name] = variableName[name];
        });
    } else {
        if (value === undefined) {
            _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
        } else {
            _RewiredData__[variableName] = value;
        }

        return value;
    }
}

function _reset__(variableName) {
    delete _RewiredData__[variableName];
}

function _with__(object) {
    var rewiredVariableNames = Object.keys(object);
    var previousValues = {};

    function reset() {
        rewiredVariableNames.forEach(function (variableName) {
            _RewiredData__[variableName] = previousValues[variableName];
        });
    }

    return function (callback) {
        rewiredVariableNames.forEach(function (variableName) {
            previousValues[variableName] = _RewiredData__[variableName];
            _RewiredData__[variableName] = object[variableName];
        });
        var result = callback();

        if (!!result && typeof result.then == 'function') {
            result.then(reset).catch(reset);
        } else {
            reset();
        }

        return result;
    };
}

var _typeOfOriginalExport = typeof anchor === 'undefined' ? 'undefined' : _typeof(anchor);

function addNonEnumerableProperty(name, value) {
    Object.defineProperty(anchor, name, {
        value: value,
        enumerable: false,
        configurable: true
    });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(anchor)) {
    addNonEnumerableProperty('__get__', _get__);
    addNonEnumerableProperty('__GetDependency__', _get__);
    addNonEnumerableProperty('__Rewire__', _set__);
    addNonEnumerableProperty('__set__', _set__);
    addNonEnumerableProperty('__reset__', _reset__);
    addNonEnumerableProperty('__ResetDependency__', _reset__);
    addNonEnumerableProperty('__with__', _with__);
    addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;